/**
 * Returns a sub-menus for `Hours Of Service` menu
 * @return Array
 */
export function hos() {
    return [
        {
            name: "Drivers",
            parentAlias: "hos",
            slug: "drivers",
            show: false,
            permissions: ["PERM_VIEW_PORTAL_DRIVERS_TAB"]
        },
        {
            name: "Logs",
            parentAlias: "hos",
            slug: "logs",
            show: false,
            permissions: ["PERM_VIEW_PORTAL_DRIVER_LOGS_TAB"]
        },
        {
            name: "Locations",
            parentAlias: "hos",
            slug: "locations",
            show: false,
            permissions: ["PERM_VIEW_PORTAL_LOCATIONS_TAB"]
        },
        {
            name: "Violations",
            parentAlias: "hos",
            slug: "violations",
            show: false,
            permissions: ["PERM_VIEW_PORTAL_VIOLATIONS_TAB"]
        },
        {
            name: "Unidentified Driving",
            parentAlias: "hos",
            slug: "unidentified-driving",
            show: false,
            permissions: ["PERM_VIEW_PORTAL_UNIDENTIFIED_DRIVING_EVENTS_TAB"]
        },
        {
            name: "Reports",
            parentAlias: "hos",
            slug: "hos-reports",
            show: false,
            permissions: ["PERM_VIEW_PORTAL_HOS_REPORTS_TAB"]
        },
        {
            name: "Malfunctions & Data Diagnostics",
            parentAlias: "hos",
            slug: "eld-malfunctions",
            show: false,
            permissions: ["PERM_VIEW_PORTAL_MALFUNCTIONS_AND_DATA_DIAGNOSTICS"]
        },
        {
            name: "Log Edits",
            parentAlias: "hos",
            slug: "log-edits",
            show: false,
            permissions: ["PERM_VIEW_PORTAL_LOG_EDITS"]
        },
        {
            name: "Data Transfer",
            parentAlias: "hos",
            slug: "data-transfer",
            show: false,
            permissions: ["PERM_VIEW_PORTAL_HOS_REPORTS_TAB"]
        }
    ];
}

/**
 * Returns a sub-menus for `DVIR` menu
 * @return Array
 */
export function dvir() {
    return [
        {
            name: "DVIR History",
            parentAlias: "dvir",
            slug: "dvir-history",
            show: true,
            permissions: ["PERM_VIEW_PORTAL_DVIR_HISTORY_TAB"]
        },
        {
            name: "Reports",
            parentAlias: "dvir",
            slug: "reports",
            show: true,
            permissions: ["PERM_VIEW_DVIR_REPORTS"]
        },
    ];
}

/**
 * Returns a sub-menus for `State Mileage` menu
 * @return Array
 */
export function ifta() {
    return [
        {
            name: "Fuel Receipts",
            parentAlias: "ifta",
            slug: "fuel-receipts",
            show: false,
            permissions: ["PERM_VIEW_PORTAL_FUEL_RECEIPTS_TAB"]
        },
        {
            name: "Reports",
            parentAlias: "ifta",
            slug: "reports",
            show: false,
            permissions: ["PERM_VIEW_PORTAL_IFTA_REPORTS_TAB"]
        }
    ];
}

/**
 * Returns a sub-menus for `Mobile Worker` menu
 * @return Array
 */
export function mobileWorker() {
    return [
        {
            name: "Jobsites",
            parentAlias: "mobile-worker",
            slug: "jobsites",
            show: false,
            permissions: ["PERM_VIEW_PORTAL_JOB_SITES_TAB"]
        },
        {
            name: "Work Orders",
            parentAlias: "mobile-worker",
            slug: "work-orders",
            show: false,
            permissions: ["PERM_VIEW_PORTAL_WORK_ORDERS_TAB"]
        },
        {
            name: "Reports",
            parentAlias: "mobile-worker",
            slug: "mobile-worker-reports",
            show: false,
            permissions: ["PERM_VIEW_PORTAL_WORK_ORDER_REPORTS_TAB"]
        }
    ];
}

/**
 * Returns a sub-menus for `Settings` menu
 * @return Array
 */
export function settings() {
    return [
        {
            name: "Accounts",
            parentAlias: "settings",
            slug: "accounts",
            show: false,
            permissions: ["PERM_IS_ACCOUNT_ADMIN"]
        },
        {
            name: "Account Settings",
            parentAlias: "settings",
            slug: "account-settings",
            show: false,
            permissions: ["PERM_IS_ACCOUNT_ADMIN"]
        },
        {
            name: "Carrier Information",
            parentAlias: "settings",
            slug: "carrier-information",
            show: false,
            permissions: ["PERM_EDIT_CARRIER_INFORMATION"]
        },
        {
            name: "Alerts",
            parentAlias: "settings",
            slug: "alerts",
            show: false,
            permissions: ["PERM_IS_ACCOUNT_ADMIN", "PERM_EDIT_ALERTS"]
        },
        {
            name: "Branding",
            parentAlias: "settings",
            slug: "branding",
            show: false,
            permissions: ["PERM_IS_ACCOUNT_ADMIN"]
        },
        {
            name: "User Profile",
            parentAlias: "settings",
            slug: "user-profile",
            show: false,
            conditions: ["hasProducts"]
        },
        {
            name: "Users",
            parentAlias: "settings",
            slug: "users",
            show: false,
            conditions: ["hasProducts", "isUserRoleAdmin"]
        },
        {
            name: "User Roles",
            parentAlias: "settings",
            slug: "user-roles",
            show: false,
            permissions: ["PERM_IS_ACCOUNT_ADMIN"]
        },
        {
            name: "Drivers",
            parentAlias: "settings",
            slug: "driver-settings",
            show: false,
            permissions: ["PERM_EDIT_DRIVERS"]
        },
        {
            name: "Driver Exceptions",
            parentAlias: "settings",
            slug: "driver-exceptions",
            show: false,
            permissions: ["PERM_IS_ACCOUNT_ADMIN"]
        },
        {
            name: "Equipment",
            parentAlias: "settings",
            slug: "equipment",
            show: false,
            permissions: ["PERM_EDIT_EQUIPMENT"]
        },
        {
            name: "Terminals",
            parentAlias: "settings",
            slug: "terminals",
            show: false,
            permissions: ["PERM_EDIT_TERMINALS"]
        },
        {
            name: "DVIR Form",
            parentAlias: "settings",
            slug: "dvir-form",
            show: false,
            permissions: ["PERM_EDIT_DVIR_FORMS"]
        },
        {
            name: "Button Editor",
            parentAlias: "settings",
            slug: "button-editor",
            show: false,
            permissions: ["PERM_IS_ACCOUNT_ADMIN"]
        },
        {
            name: "Form Setup",
            parentAlias: "settings",
            slug: "form-setup",
            show: false,
            permissions: ["PERM_IS_ACCOUNT_ADMIN"]
        },
        {
            name: "User Interface",
            parentAlias: "settings",
            slug: "user-interface",
            show: false,
            conditions: ["hasProducts"]
        },
        {
            name: "Push Data",
            parentAlias: "settings",
            slug: "push-data",
            show: false,
            permissions: ["PERM_IS_ACCOUNT_ADMIN"]
        },
        {
            name: "Push Notifications",
            parentAlias: "settings",
            slug: "push-notifications",
            show: false,
            permissions: ["PERM_IS_ACCOUNT_ADMIN"]
        },
        {
            name: "Child account support",
            parentAlias: "settings",
            slug: "support-contact",
            show: false,
            permissions: ["PERM_SUPPORT_CONTACT_TAB_VIEW"]
        },
        {
            name: "Upload Resources",
            parentAlias: "settings",
            slug: "upload-resources",
            show: false,
            permissions: ["PERM_SUPPORT_CONTACT_TAB_VIEW"]
        },
        {
            name: "Resources",
            parentAlias: "settings",
            slug: "download-resources",
            show: false,
            permissions: ["hasProducts"]
        }
    ];
}

/**
 * Returns a sub-menus for `Admin Tools` menu
 * @return Array
 */
export function adminTools() {
    return [
        {
            name: "Data Transfer",
            parentAlias: "admin-tools",
            slug: "data-transfer-admin",
            show: false,
            permissions: ["PERM_IS_SYS_ADMIN"]
        },
        {
            name: "Module management",
            parentAlias: "admin-tools",
            slug: "module-management",
            show: false,
            permissions: ["PERM_IS_SYS_ADMIN"]
        },
        {
            name: "State Mileage Tax Rate",
            parentAlias: "admin-tools",
            slug: "ifta-tax-rate",
            show: false,
            permissions: ["PERM_IS_SYS_ADMIN"]
        },
        {
            name: "Billing Reports",
            parentAlias: "admin-tools",
            slug: "billing-reports",
            show: false,
            permissions: ["PERM_IS_SYS_ADMIN"]
        },
        {
            name: "Base Product Pricing",
            parentAlias: "admin-tools",
            slug: "base-product-pricing",
            show: false,
            permissions: ["PERM_IS_SYS_ADMIN"]
        },
        {
            name: "AESI Monitor",
            parentAlias: "admin-tools",
            slug: "aesi-monitor",
            show: false,
            permissions: ["PERM_IS_SYS_ADMIN"]
        },
        {
            name: "Email Notifications",
            parentAlias: "admin-tools",
            slug: "email-notifications",
            show: false,
            permissions: ["PERM_IS_SYS_ADMIN"]
        },
        {
            name: "Reseller Keys",
            parentAlias: "admin-tools",
            slug: "reseller-keys",
            show: false,
            permissions: ["PERM_IS_SYS_ADMIN"]
        },
          {
            name: "App Release Notifications",
            parentAlias: "admin-tools",
            slug: "app-release-notifications",
            show: false,
            permissions: ["PERM_IS_SYS_ADMIN"]
        }
    ];
}

export const subMenus = {
    hos,
    dvir,
    ifta,
    settings,
    adminTools,
    mobileWorker,
};
